var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCfAddress(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 33,
    viewBox: "0 0 26 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7667 31.3544C1.68562 18.1894 0 16.8383 0 12C0 5.37256 5.37256 0 12 0C18.6274 0 24 5.37256 24 12C24 16.8383 22.3144 18.1894 13.2332 31.3544C12.6373 32.2152 11.3626 32.2152 10.7667 31.3544ZM12 17C14.7614 17 17 14.7614 17 12C17 9.23856 14.7614 7 12 7C9.23856 7 7 9.23856 7 12C7 14.7614 9.23856 17 12 17Z",
    fill: "#97B1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7667 32.3544C3.68562 19.1894 2 17.8383 2 13C2 6.37256 7.37256 1 14 1C20.6274 1 26 6.37256 26 13C26 17.8383 24.3144 19.1894 15.2332 32.3544C14.6373 33.2152 13.3626 33.2152 12.7667 32.3544ZM14 18C16.7614 18 19 15.7614 19 13C19 10.2386 16.7614 8 14 8C11.2386 8 9 10.2386 9 13C9 15.7614 11.2386 18 14 18Z",
    fill: "#CBD8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCfAddress);
export default __webpack_public_path__ + "static/media/cf-address.7410a6a97e01e028912fddaf0f15faeb.svg";
export { ForwardRef as ReactComponent };